export default "__VITE_ASSET__Dxsk3N22__"